import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';
import Modal from '../elements/Modal';
import Logo from '../layout/partials/Logo';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

export const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <Logo>logo</Logo>
            <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
            Cohorts Postcards<br/><span className="text-color-primary">Designers Color Palettes Edition.</span>
            </h1>
            <div className="container-xs">
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                Express yourself with colorful posts in Microsoft Teams.
                </p>
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                Try it for free from Microsoft app store for Microssoft Teams. 
              </p>
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                Donations are appreciated! <a href="https://www.buymeacoffee.com/6WONjZKSz" target="_blank">Click to Buy Me a Coffee!!</a> 
              </p>
              
            </div>
          </div>
<br></br>
          <div>
              <Image
                className="has-shadow"
                src={require('./../../assets/images/Team1.jpg')}
                alt="Hero"
                width="100%"
                height="100%" />
          
          </div>
          
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

